import { render, staticRenderFns } from "./BranchRegionReportComponent.vue?vue&type=template&id=01b0e674&scoped=true"
import script from "./BranchRegionReportComponent.vue?vue&type=script&lang=js"
export * from "./BranchRegionReportComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchRegionReportComponent.vue?vue&type=style&index=0&id=01b0e674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0e674",
  null
  
)

export default component.exports